export const errorResponse = (err) => ({ success: false, resultMessage: err.message })
export const successResponse = (resp) => {
  return {
    success: true,
    data: resp
  }
}
